import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const Notebar = ({ activeWidgets, toggleWidget, addNote }) => {
  const [noteText, setNoteText] = useState('');
  const [sortOption, setSortOption] = useState('Newest');
  const fileInputRef = useRef(null);
  const navigate = useNavigate();

  const handleNoteChange = (e) => setNoteText(e.target.value);

  const handleAddNote = () => {
    if (!noteText.trim()) return;
    addNote(noteText);
    setNoteText('');
  };

  const handleFileUploadClick = () => fileInputRef.current.click();

  const handleFileChange = (e) => {
    const files = e.target.files;
    console.log(files);
  };

  const handleSettingsClick = () => navigate('/settings');

  return (
    <div style={styles.notebar}>
      {/* Toolbar */}
      <div style={styles.toolbar}>
        {/* Sort Filter */}
        <div style={styles.sortFilter}>
          <label htmlFor="sort" style={styles.sortLabel}>Sort By:</label>
          <select
            id="sort"
            value={sortOption}
            onChange={(e) => setSortOption(e.target.value)}
            style={styles.sortSelect}
          >
            <option value="Newest">Newest</option>
            <option value="Oldest">Oldest</option>
            <option value="Most Liked">Most Liked</option>
          </select>
        </div>

        {/* Textarea Input */}
        <textarea
          placeholder="Write a note..."
          value={noteText}
          onChange={handleNoteChange}
          style={styles.textInput}
        />

        {/* Done Button */}
        <button style={styles.doneButton} onClick={handleAddNote}>
          Done
        </button>
      </div>

      {/* Navigation Bar */}
      <div style={styles.navbar}>
        <div style={styles.leftButtons}>
          {[
            ['📝 Notes History', 'notes-history'],
            ['📅 Calendar', 'calendar'],
            ['💡 Suggestions', 'suggestions'],
            ['📖 Wiki', 'wiki'],
            ['📊 Project', 'project'],
          ].map(([label, key]) => (
            <button
              key={key}
              style={{
                ...styles.navButton,
                ...(activeWidgets.includes(key) ? styles.activeNavButton : {}),
              }}
              onClick={() => toggleWidget(key)}
            >
              {label}
            </button>
          ))}
        </div>

        <div style={styles.rightButtons}>
          <button style={styles.smallButton} onClick={handleSettingsClick}>
            ⚙️ Settings
          </button>
          <button style={styles.smallButton} onClick={handleFileUploadClick}>
            📁 Upload
          </button>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
        </div>
      </div>
    </div>
  );
};

const styles = {
  notebar: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    backgroundColor: '#f8f9fa',
    borderTop: '1px solid #ccc',
    padding: 'min(10px, 2vw)',
    zIndex: 1000,
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '10px',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '10px',
  },
  sortFilter: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '10px',
  },
  sortLabel: {
    marginRight: '5px',
    fontWeight: 'bold',
  },
  sortSelect: {
    padding: '5px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    fontSize: '1rem',
  },
  textInput: {
    flex: 1,
    minWidth: '200px',
    padding: '10px',
    fontSize: '1rem',
    border: '1px solid #ccc',
    borderRadius: '5px',
    marginRight: '10px',
  },
  doneButton: {
    padding: '10px 20px',
    fontSize: '1rem',
    fontWeight: 'bold',
    color: '#fff',
    backgroundColor: '#007bff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  },
  navbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTop: '1px solid #ddd',
    paddingTop: '10px',
  },
  leftButtons: {
    display: 'flex',
    gap: '5px',
  },
  rightButtons: {
    display: 'flex',
    gap: '5px',
  },
  navButton: {
    padding: 'min(10px, 2vw)',
    minWidth: '80px',
    fontSize: 'clamp(0.8rem, 2vw, 1rem)',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    transition: 'color 0.3s ease, background-color 0.3s ease',
  },
  activeNavButton: {
    color: '#fff',
    backgroundColor: '#007bff',
    borderRadius: '5px',
  },
  smallButton: {
    padding: '5px 10px',
    fontSize: '0.8rem',
    fontWeight: 'bold',
    color: '#fff',
    backgroundColor: '#007bff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  },
};

export default Notebar;
